export default __webpack_public_path__ + "static/media/email.265c4839.svg";